export const HOME_DATA="HOME_DATA"





